const AnguillaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110753)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C0 20.0048 20 0.0021875 20 0C31.0456 0 40 8.95437 40 20Z"
        fill="#0052B4"
      />
      <path
        d="M19.9468 19.9998H20.0003C20.0003 19.9818 20.0003 19.9643 20.0003 19.9463C19.9825 19.9642 19.9647 19.982 19.9468 19.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 10.4348C20 6.91563 20 4.60977 20 0H19.9966C8.95242 0.001875 0 8.95539 0 20H10.4348V14.1241L16.3106 20H19.9466C19.9644 19.9822 19.9822 19.9644 20.0001 19.9465C20.0001 18.5991 20.0001 17.3968 20.0001 16.3108L14.1241 10.4348H20Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.1181 2.6084C6.99004 4.38957 4.38949 6.99004 2.6084 10.1181V19.9997H7.82582V7.82598V7.82582H19.9997C19.9997 6.18027 19.9997 4.61262 19.9997 2.6084H10.1181Z"
        fill="#D80027"
      />
      <path
        d="M19.9993 17.5403L12.8935 10.4346H10.4341V10.4347L19.9992 19.9997H19.9993C19.9993 19.9997 19.9993 18.3039 19.9993 17.5403Z"
        fill="#D80027"
      />
      <path
        d="M33.8231 22.9273C34.3982 22.1361 34.7823 21.1698 34.7823 19.9996V11.304C34.0556 11.85 33.1525 12.1736 32.1736 12.1736C30.7513 12.1736 29.4886 11.4905 28.6954 10.4346C27.9021 11.4905 26.6393 12.1736 25.2171 12.1736C24.2382 12.1736 23.335 11.8499 22.6084 11.3042V19.9996C22.6084 21.1698 22.9925 22.1361 23.5676 22.9273H33.8231Z"
        fill="#F3F3F3"
      />
      <path
        d="M32.0145 18.3862C32.2913 17.7107 32.5067 16.7234 32.5067 16.2321C32.5067 15.4427 31.4774 14.8027 31.4774 14.8027C31.4774 14.8027 30.4482 15.4427 30.4482 16.2321C30.4482 16.7235 30.6636 17.7108 30.9403 18.3862L30.3462 19.7277C30.6954 19.8697 31.0771 19.9486 31.4775 19.9486C31.8779 19.9486 32.2596 19.8696 32.6088 19.7277L32.0145 18.3862Z"
        fill="#FF9811"
      />
      <path
        d="M27.9919 14.0436C27.2688 14.1416 26.3061 14.449 25.8806 14.6946C25.1969 15.0894 25.1572 16.3006 25.1572 16.3006C25.1572 16.3006 26.2261 16.8719 26.9097 16.4772C27.3353 16.2315 28.0825 15.5515 28.5289 14.974L29.9879 14.8178C29.9363 14.4445 29.8135 14.0744 29.6136 13.7278C29.4132 13.3811 29.1543 13.0899 28.8566 12.8584L27.9919 14.0436Z"
        fill="#FF9811"
      />
      <path
        d="M26.2417 19.6987C26.688 20.2759 27.4354 20.9558 27.8611 21.2016C28.5447 21.5963 29.6136 21.0251 29.6136 21.0251C29.6136 21.0251 29.5737 19.8138 28.8902 19.419C28.4645 19.1733 27.5019 18.8662 26.7787 18.7684L25.914 17.583C25.6165 17.8144 25.3574 18.1058 25.1572 18.4521C24.9571 18.7989 24.8346 19.1689 24.7827 19.5424L26.2417 19.6987Z"
        fill="#FF9811"
      />
      <path
        d="M23.353 22.6084C24.9771 25.2143 28.6959 26.0865 28.6959 26.0865C28.6959 26.0865 32.4147 25.2143 34.0388 22.6084H23.353Z"
        fill="#338AF3"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110753">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default AnguillaSvg;
